import { transition } from '@helpers/animate';
import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import { ButtonReset } from '@helpers/global';
import { baseGrid } from '@helpers/grid';
import SectionWrapper from '@stories/Components/Misc/SectionWrapper/SectionWrapper';
import SectionWrapperStyles from '@stories/Components/Misc/SectionWrapper/SectionWrapper.styles';
import styled from 'styled-components';
import { centralColumns } from '../RichText/RichText.styles';
const Container = styled(SectionWrapper) `
  ${SectionWrapperStyles.Inner} {
    ${baseGrid};
  }

  @media print {
    display: none;
  }
`;
const Inner = styled.div `
  grid-column: 1 / -1;

  ${centralColumns};
`;
const LinkList = styled.div `
  display: flex;
  flex-wrap: wrap;
  gap: ${fluid(24, 24)};
`;
const Item = styled.div ``;
const Link = styled.a `
  ${ButtonReset};
  ${fonts.lato.bold}
  font-size: ${fluid(15, 16)};
  line-height: ${fluid(23, 26)};
  display: inline-flex;
  gap: ${fluid(7, 8)};
  align-items: center;
  text-decoration: none;
  color: ${brand.primary.purple.light};
  width: fit-content;

  &:focus-visible,
  &.focus-ring {
    outline: auto;
    outline-offset: 3px;
    outline-width: 2px;
  }
`;
const Icon = styled.div `
  ${transition('backgroun-color')};
  width: ${fluid(28, 40)};
  height: ${fluid(28, 40)};
  border: 1px solid ${brand.primary.purple.light};
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${brand.global.white};

  svg {
    ${transition('color')};
    width: ${fluid(16, 24)};
    height: ${fluid(16, 24)};
    color: ${brand.primary.purple.light};
  }

  &[data-saved='true'] {
    svg {
      width: ${fluid(10, 14)};
      height: ${fluid(10, 14)};
    }
  }

  ${Link}:hover & {
    background-color: ${brand.primary.purple.light};

    svg {
      color: ${brand.global.white};
    }
  }
`;
export const SharePrintSaveStyles = {
    Container,
    Icon,
    Inner,
    Item,
    Link,
    LinkList,
};
